var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 419.84 419.84",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.92 0C93.696 0 0 93.696 0 209.92s93.696 209.92 209.92 209.92 209.92-93.696 209.92-209.92S326.144 0 209.92 0zm93.184 219.648-139.776 81.92c-1.536 1.024-4.096 1.536-5.632 1.536s-4.096-.512-5.632-1.536c-3.584-2.56-5.632-5.632-5.632-9.728V128.512h-.512c0-4.096 2.56-8.192 5.632-9.728 3.072-1.536 8.192-2.56 11.776 0l139.776 81.408c3.584 2.56 5.632 5.632 5.632 9.728s-2.56 8.192-5.632 9.728z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.67ef8cf796993552c08faa191edd1ce9.svg";
export { ForwardRef as ReactComponent };